import React from 'react'
import User from '../../assets/images/user.png'
const MyFeeds = () => {

  const data = [
    {
      'profileImg': User ,
      'userName': 'Marry Clemin had updated',
      'doc': 'Credit_card_terms_and_Conditions.pdf',
      'duration': ' 3 Mins Ago',
      'description': "Hello! Thank you for your interest in opening a savings account with us. I'd be happy to assist you with that. To open a savings account, you typically need to provide some personal information and identification documents. You can go on our website digital.sbbank.com to know more about opening savings account. Hello! Thank you for your interest in opening a savings account with us. I'd be happy to assist you with that. To open a savings account, you typically need to provide some personal information and identification documents. You can go on our website digital.sbbank.com to know more about opening savings account.Hello! Thank you for your interest in opening a savings account with us. I'd be happy to assist you with that. To open a savings account, you typically need to provide some personal information and identification documents. You can go on our website digital.sbbank.com to know more about opening savings account.",
    },
    {
      'profileImg': User ,
      'userName': 'John Markson has updated',
      'doc': 'Credit_card_terms_and_Conditions.pdf',
      'duration': ' 3 Mins Ago',
      // 'coverImg' : myfeeds,
      'description': "Hello! Thank you for your interest in opening a savings account with us. I'd be happy to assist you with that. To open a savings account, you typically need to provide some personal information and identification documents. You can go on our website digital.sbbank.com to know more about opening savings account.",
    },
  ]
  return (
    <>
      <div className='myfeeds-wrapper'>
        {data.map((item, index) => (
          <div className='myfeeds-list' key={index}>
            <div className='mf-top'>
              <div className='mf-top1'>
                <img src={item.profileImg} />
                <div className='mf-top-inner-1'>
                  <h5>{item.userName}</h5>
                  <p>
                    <span></span>
                    {item.doc}
                  </p>
                </div>
              </div>
              <div className='mf-top2'>
                <span></span>
                <div>
                  <span></span>
                  {item.duration}
                </div>
              </div>
            </div>
            <div className='mf-bottom'>
              <img src={item.coverImg} />
              {item.description}
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default MyFeeds
